<template>
  <div
    id="vue_whatsapp_storm"
    :rtl="$props.rtl === 'true'"
    :right="$props.position === 'right'"
    :left="$props.position === 'left'"
    :layout="$props.layout"
  >
    <div
      class="vue_whatsapp_storm-chat"
      :class="isOpen === true ? 'vue_whatsapp_storm-chat--open' : ''"
    >
      <div class="vue_whatsapp_storm-header">
        <div class="vue_whatsapp_storm-header--heading">
          ¿Necesitas ayuda? Háblanos
        </div>
        <div class="vue_whatsapp_storm-header--subheading">
          Los representantes que se encuentran abajo responderán tan pronto como vean tu mensaje.
        </div>
      </div>
      <div class="vue_whatsapp_storm-body">
        <a
          :href="'https://wa.me/' + contact.number"
          target="_blank"
          class="vue_whatsapp_storm-chat--contact"
          :class="'vue_whatsapp_storm-chat--contact_' + contact.status"
          v-for="contact in contacts"
          :key="contact.number"
          v-show="contact.online === true"
        >
          <div class="vue_whatsapp_storm-chat--contact_avatar">
            <img :src="contact.avatar" alt="" />
            <div
              class="vue_whatsapp_storm-chat--contact_status"
              v-show="$props.layout === 'style2'"
            ></div>
          </div>
          <div class="vue_whatsapp_storm-chat--contact_content">
            <div class="vue_whatsapp_storm-chat--contact_content-heading">
              {{ contact.title }}
            </div>
            <div class="vue_whatsapp_storm-chat--contact_content-sub">
              {{ contact.subtitle }}
            </div>
            <div
              class="vue_whatsapp_storm-chat--contact_status"
              v-show="$props.layout === 'style1' || $props.layout === undefined"
            >
              {{ contact.status }}
            </div>
          </div>
        </a>
        <div
          class="vue_whatsapp_storm-chat--not_available"
          v-if="contacts.filter((item) => item.online === true).length === 0"
        >
          No Representattive are available now, please come back later
        </div>
      </div>
      <div
        class="vue_whatsapp_storm-footer"
        v-show="contacts.filter((item) => item.online === true).length === 1"
      >
        <div>
          <input
            v-model="message"
            type="text"
            class="vue_whatsapp_storm-input"
            placeholder="Escribe tu mensaje aquí.."
          />
          <button
            @click="
              sendMessage(
                contacts.filter((item) => item.online === true)[0].number
              )
            "
          >
            <svg
              version="1.1"
              id="Capa_1"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              x="0px"
              y="0px"
              viewBox="0 0 512 512"
              style="enable-background: new 0 0 512 512"
              xml:space="preserve"
            >
              <g>
                <g>
                  <path
                    d="M481.508,210.336L68.414,38.926c-17.403-7.222-37.064-4.045-51.309,8.287C2.86,59.547-3.098,78.551,1.558,96.808
			L38.327,241h180.026c8.284,0,15.001,6.716,15.001,15.001c0,8.284-6.716,15.001-15.001,15.001H38.327L1.558,415.193
			c-4.656,18.258,1.301,37.262,15.547,49.595c14.274,12.357,33.937,15.495,51.31,8.287l413.094-171.409
			C500.317,293.862,512,276.364,512,256.001C512,235.638,500.317,218.139,481.508,210.336z"
                  />
                </g>
              </g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
            </svg>
          </button>
        </div>
      </div>
    </div>
    <div class="vue_whatsapp_storm-fab" @click="triggerChatBox">
      <svg
        v-show="isOpen"
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
      >
        <path
          d="M23.954 21.03l-9.184-9.095 9.092-9.174-2.832-2.807-9.09 9.179-9.176-9.088-2.81 2.81 9.186 9.105-9.095 9.184 2.81 2.81 9.112-9.192 9.18 9.1z"
        />
      </svg>

      <svg
        v-show="!isOpen"
        height="30px"
        viewBox="-23 -21 682 682.66669"
        width="30px"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="m544.386719 93.007812c-59.875-59.945312-139.503907-92.9726558-224.335938-93.007812-174.804687 0-317.070312 142.261719-317.140625 317.113281-.023437 55.894531 14.578125 110.457031 42.332032 158.550781l-44.992188 164.335938 168.121094-44.101562c46.324218 25.269531 98.476562 38.585937 151.550781 38.601562h.132813c174.785156 0 317.066406-142.273438 317.132812-317.132812.035156-84.742188-32.921875-164.417969-92.800781-224.359376zm-224.335938 487.933594h-.109375c-47.296875-.019531-93.683594-12.730468-134.160156-36.742187l-9.621094-5.714844-99.765625 26.171875 26.628907-97.269531-6.269532-9.972657c-26.386718-41.96875-40.320312-90.476562-40.296875-140.28125.054688-145.332031 118.304688-263.570312 263.699219-263.570312 70.40625.023438 136.589844 27.476562 186.355469 77.300781s77.15625 116.050781 77.132812 186.484375c-.0625 145.34375-118.304687 263.59375-263.59375 263.59375zm144.585938-197.417968c-7.921875-3.96875-46.882813-23.132813-54.148438-25.78125-7.257812-2.644532-12.546875-3.960938-17.824219 3.96875-5.285156 7.929687-20.46875 25.78125-25.09375 31.066406-4.625 5.289062-9.242187 5.953125-17.167968 1.984375-7.925782-3.964844-33.457032-12.335938-63.726563-39.332031-23.554687-21.011719-39.457031-46.960938-44.082031-54.890626-4.617188-7.9375-.039062-11.8125 3.476562-16.171874 8.578126-10.652344 17.167969-21.820313 19.808594-27.105469 2.644532-5.289063 1.320313-9.917969-.664062-13.882813-1.976563-3.964844-17.824219-42.96875-24.425782-58.839844-6.4375-15.445312-12.964843-13.359374-17.832031-13.601562-4.617187-.230469-9.902343-.277344-15.1875-.277344-5.28125 0-13.867187 1.980469-21.132812 9.917969-7.261719 7.933594-27.730469 27.101563-27.730469 66.105469s28.394531 76.683594 32.355469 81.972656c3.960937 5.289062 55.878906 85.328125 135.367187 119.648438 18.90625 8.171874 33.664063 13.042968 45.175782 16.695312 18.984374 6.03125 36.253906 5.179688 49.910156 3.140625 15.226562-2.277344 46.878906-19.171875 53.488281-37.679687 6.601563-18.511719 6.601563-34.375 4.617187-37.683594-1.976562-3.304688-7.261718-5.285156-15.183593-9.253906zm0 0"
          fill-rule="evenodd"
        />
      </svg>
    </div>
  </div>
</template>

<script>
export default {
  name: "VueWhatsappStorm",
  props: ["position", "rtl", "layout"],
  data() {
    return {
      message: "",
      isOpen: false,
      contacts: [
        {
          title: "Jacinto Vega",
          subtitle: "Representante de Ventas",
          status: "online",
          online: true,
          number: "13362676114",
          avatar: "https://randomuser.me/api/portraits/men/99.jpg",
        },
      ],
    };
  },
  methods: {
    triggerChatBox() {
      this.isOpen = !this.isOpen;
    },
    sendMessage(phone) {
      window.open("https://wa.me/" + phone + "/?text=" + this.message);
    },
  },
};
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Roboto:wght@400;500&display=swap");

#vue_whatsapp_storm,
#vue_whatsapp_storm * {
  box-sizing: border-box;
}

#vue_whatsapp_storm {
  font-family: "Roboto", sans-serif;
  position: fixed;
  right: 15px;
  bottom: 15px;
  z-index: 9999;
}

.vue_whatsapp_storm-fab {
  width: 50px;
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #25d366;
  border-radius: 50px;
  padding: 5px;
  box-shadow: 0px 4px 4px rgb(0 0 0 / 20%);
}

.vue_whatsapp_storm-fab svg {
  fill: #fff;
}

.vue_whatsapp_storm-chat {
  background-color: #25d366;
  min-height: 100px;
  width: 300px;
  border-radius: 13px;
  position: absolute;
  bottom: 70px;
  right: 0;
  box-shadow: 2px 2px 5px rgb(0 0 0 / 20%);
  overflow: hidden;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
  transform: scale(0.9);
  transition: all 0.3s ease;
}

.vue_whatsapp_storm-chat.vue_whatsapp_storm-chat--open {
  opacity: 1;
  visibility: visible;
  pointer-events: auto;
  transform: scale(1);
}

.vue_whatsapp_storm-header {
  text-align: left;
  color: #fff;
  padding-bottom: 5px;
  padding-top: 30px;
  padding-left: 15px;
  padding-right: 15px;
}

.vue_whatsapp_storm-header--heading {
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 5px;
}

.vue_whatsapp_storm-header--subheading {
  font-size: 14px;
  color: #fffa;
}

.vue_whatsapp_storm-body {
  text-align: left;
  color: #fff;
  padding: 15px;
}

.vue_whatsapp_storm-header--heading {
  font-size: 20px;
  font-weight: bold;
}

.vue_whatsapp_storm-header--subheading {
  font-size: 14px;
  color: #fffa;
}

.vue_whatsapp_storm-chat--contact {
  color: #000;
  display: flex;
  background-color: #fff;
  padding: 15px;
  border-radius: 5px;
  margin-bottom: 5px;
  text-decoration: none;
  box-shadow: 0px 1px 3px rgb(0 0 0 / 20%);
  position: relative;
}

a.vue_whatsapp_storm-chat--contact.vue_whatsapp_storm-chat--contact_offline {
  opacity: 0.5;
  pointer-events: none;
}

.vue_whatsapp_storm-chat--contact:last-of-type {
  margin-bottom: 0;
}

.vue_whatsapp_storm-chat--contact_content {
  margin: 0 10px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.vue_whatsapp_storm-chat--contact_content-heading {
  font-weight: bold;
  font-size: 16px;
}

.vue_whatsapp_storm-chat--contact_content-sub {
  color: #25d366;
  font-size: 12px;
}

.vue_whatsapp_storm-chat--contact_avatar {
  width: 40px;
  position: relative;
}

.vue_whatsapp_storm-chat--contact_status {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 10px;
  color: #fff;
  background-color: #25d366;
  padding: 5px;
  border-radius: 15px;
}

.vue_whatsapp_storm-chat--contact_avatar
  .vue_whatsapp_storm-chat--contact_status {
  right: 0;
  bottom: 0;
  top: auto;
}

.vue_whatsapp_storm-chat--contact_avatar img {
  max-width: 100%;
  height: auto;
  border-radius: 40px;
}

.vue_whatsapp_storm-fab {
  position: relative;
}

span.vue_whatsapp_storm-fab--close {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

span.vue_whatsapp_storm-fab--close > span {
  background-color: #fff;
  display: block;
  width: 24px;
  height: 3px;
  transform: rotate(45deg);
  transform-origin: center;
}

span.vue_whatsapp_storm-fab--close > span:last-of-type {
  transform: rotate(-45deg);
}

.vue_whatsapp_storm-fab {
  position: relative;
}

input.vue_whatsapp_storm-input {
  width: 100%;
  border: 0;
  height: 42px;
  padding: 10px 20px;
  border-top: 1px solid #eee;
}

input.vue_whatsapp_storm-input:focus {
  outline: 0 none;
  box-shadow: none;
}

.vue_whatsapp_storm-footer {
  position: relative;
}

.vue_whatsapp_storm-footer button {
  background-color: transparent;
  border: 0;
  box-shadow: none;
  color: transparent;
  height: auto;
  width: auto;
  position: absolute;
  top: 54%;
  right: 3px;
  transform: translateY(-50%);
}

.vue_whatsapp_storm-footer button svg {
  width: 21px;
  height: 21px;
  fill: #25d366;
}

.vue_whatsapp_storm-chat--not_available {
  color: #aaa;
}

/* left position */

div#vue_whatsapp_storm[left="true"] {
  right: auto;
  left: 15px;
}

div#vue_whatsapp_storm[left="true"] .vue_whatsapp_storm-chat {
  right: auto;
  left: 0;
}

/* rtl */

div#vue_whatsapp_storm[rtl="true"] .vue_whatsapp_storm-chat--contact {
  flex-direction: row-reverse;
  text-align: right;
}

div#vue_whatsapp_storm[rtl="true"] .vue_whatsapp_storm-chat--contact_status {
  right: auto;
  left: 12px;
}

div#vue_whatsapp_storm[rtl="true"] .vue_whatsapp_storm-header {
  text-align: right;
}

div#vue_whatsapp_storm[rtl="true"]
  .vue_whatsapp_storm-chat--contact_avatar
  .vue_whatsapp_storm-chat--contact_status {
  left: 0;
  right: auto;
}

div#vue_whatsapp_storm[rtl="true"] .vue_whatsapp_storm-footer button {
  left: 3px !important;
  right: auto;
  transform: translateY(-50%) rotate(180deg);
}

div#vue_whatsapp_storm[rtl="true"] .vue_whatsapp_storm-footer input {
  text-align: right;
}


/* layouts */

div#vue_whatsapp_storm[layout="style2"] .vue_whatsapp_storm-body {
  background-color: #fff;
}

div#vue_whatsapp_storm[layout="style2"] .vue_whatsapp_storm-header {
  padding-bottom: 15px;
}
</style>